import BannerHomeService from '../services/banner.home.service';

export const bannerHome = {
  namespaced: true,
  actions: {
    get({ commit }) {
      return BannerHomeService.get();
      // return BannerHomeService.get().then(
      //   resp => {
      //     return Promise.resolve(resp);
      //   },
      //   error => {
      //     return Promise.reject(error);
      //   }
      // );
    }
  },
  mutations: {
    }
};
